

export const BaseEndpoints = {
  March25Followup: "march25-followup",
  systemTypeSetting: "system-types-settings",
  subSystemSetting: "sub-system-settings",
  systemSetting: "system-settings",
  modelSetting: "model-settings",
  glassFinishSettings: "glass-finish-settings",
  glassSubCategoriesSettings: "glass-sub-categories-settings",
  handlesSettings: "handles-settings",
  frameColorsSettings: "frame-colors-settings",
  csMasterSettings: "cs-master-settings",
  gridSettings: "grid",
  lockSettings: "lock-settings",
  glassCategoriesSettings: "glass-categories-settings",
  addressesProvider: "addresses-provider",
  order: "order",
  payment: "payment",
  observationError: "observation-error",
  refundPayment: "refund-payment",
  refundPaymentV2: "refund-payment/v2",
  paymentHistory: "payment-history",
  user: "user",
  office: "office",
  indiaDesign: "india-design",
  role: "role",
  download: "download",
  source: "sources",
  generalSettings: "general-settings",
  HsnCodeGstMapping: "hsncode-gstmapping",
  desginSettings: "design-settings",
  glassVariantSettings: "glass-variant-settings",
  hingeSetting: "hinge-settings",
  educationModule: "education-module",
  glassOrder: "glass-order",
  analytics: "analytics",
  modules: "modules",
  priceVersion: "price-version",
  states: "states",
  cities: "cities",
  countries: "countries",
  architectDetails: "architect-details",
  orderPercentage: "order-percentage",
  whatsapp: "whatsapp",
  dashboard: "dashboard",
  campaign: 'campaign',
  waltzOder: "waltz-order",
  panelOnly: "panel-only",
  redFlag: "red-flag",
  RedRibbon: "red-ribbon",
  quotationRequestUsers: "quotation-users-request",
  website: "website",
  tags: "tags",
  album: 'album',
  photo: 'photo',
  jbConnect: 'jb-connect',
  userSignInTrack: 'user-sign-in-track',
  onlineUsers: 'online-users',
  accessoryOnly: 'accessory-only',
  productionPlanning: 'production-planning',
  workOrder: "work-order",
  productionTracker: "production-tracker",
  paintJobTracking: "paint-job-tracking",
  locationTracker: "location-tracker",
  projectTracker: "project-tracker",
  b2b: 'b2b',
  deliveryAdvice: 'delivery-advice',
  meetingConfigurationSeeting: "meeting-configuration-settings",
  splitWorkOrder: "split-work-order",
  verifyOrder: "verify-order",
  documentation: "documentation",
  socials: "state-to-user",
  leads: "social-leads",
  drawingSettings: "drawing-settings",
  drawingPlan: "drawing-plan",
  metaforms: "meta-form",
  transporterSetting: "transporter-settings",
  insuranceAgent: "insurance-agent",
  invoiceTearmsAndConditionsSettings: "invoice-terms-condition-settings",
  insuranceSettings: "insurance-settings",
  preWorkOrder: "pre-work-order",
  mapbox: "mapbox-utilities",
  email: "email",
  jbUploader: "jb-uploader",
  eInvoice: "e-invoice",
  creditNote: "credit-note",
  ImportModelHsn: "import-model-hsn",
  ImportPanelHsn: "import-panel-only-hsn",
  ImportAccessoryHsn: "import-accessory-only-hsn",
  LedgerForm: "ledger-form",
  Impersonate: "impersonate",
  TBS: "tbs",
  TBSCategory: "tbs-category",
  DraftWorkOrder: "draft-work-order",
  ErrorProductionTeam: "error-production-team",
  trustSeal: "trust-seal",
  DepartmentSupply: "department-supply",
  workflowRouteSetting: "workflow-route-settings",
  ProductionMasters: "production-masters",
  GoogleUtilities: "google-utilities",
  csMasterTypes: "settings/cs-master-types",
  bomModelWiseMapping: "settings/bom-model-wise-mapping",
  rmProjection: "rm-projection",
  bomMappingUom: "settings/bom-mapping-uom",
};
